export const authNotExisted = { code: 401, message: 'auth info does not exist' }
export const authDataCorrupted = { code: 401, message: 'authentication data corrupted' }
export const tokenExpired = { code: 401, message: 'token expired' }
export const codePasswordExpired = 267